// import { stat } from "fs";

 // import {productListView} from './actions' 

const initialState = {
  windowDetails:''
  }

export default function productListView(state = initialState, action) {

   if(action.type==='DISPLAY_WINDOW_DETAILS'){
    return {
      ...state,
      records:action.payload,
      windowDetails:action.payload
    
    }
  }
  
  
  return state
}